// ✅ Updated Playlist.js with selected channel logic
import React, { useEffect, useState } from 'react';
import ChannelCard from './ChannelCard';

function Playlist() {
  const [channels, setChannels] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [favorites, setFavorites] = useState(() => JSON.parse(localStorage.getItem('favs')) || []);
  const [search, setSearch] = useState('');
  const [group, setGroup] = useState('All');
  const [year, setYear] = useState('All');
  const [loading, setLoading] = useState(true);
  const [selectedPlaylist, setSelectedPlaylist] = useState('1');
  const [showModal, setShowModal] = useState(false);
  const [playStoreUrl, setPlayStoreUrl] = useState('');
  const [selectedUrl, setSelectedUrl] = useState(null); // ✅ New selected state

  const proxy = '/api/proxy.js?url=';
  const customPlaylists = JSON.parse(localStorage.getItem('custom_playlists') || '[]');

  const basePlaylists = {
    '1': { name: '🎥Sport M3U(အစုံ)', url: 'http://restream-live.realiptv.to:8080/get.php?username=meme&password=meme&type=m3u', type: 'm3u' },
    '2': { name: '🎥Sport M3U(အစုံ)', url: 'https://iptv-org.github.io/iptv/categories/sports.m3u', type: 'm3u' },
    '3': { name: '🎥English M3U(အစုံ)', url: 'https://iptv-org.github.io/iptv/languages/eng.m3u', type: 'm3u' },
    '4': { name: '🎥Xiaomi M3U(အစုံ)', url: 'https://www.apsattv.com/xiaomi.m3u', type: 'm3u' },
    '5': { name: '🌎All Country M3U', url: 'https://raw.githubusercontent.com/Free-TV/IPTV/master/playlist.m3u8', type: 'm3u' },
    '6': { name: '🇻🇳Vietnam M3U', url: 'https://iptv-org.github.io/iptv/countries/vn.m3u', type: 'm3u' },
    '7': { name: '🇹🇭Thailand M3U', url: 'https://iptv-org.github.io/iptv/countries/th.m3u', type: 'm3u' },
    '8': { name: '🇸🇬Singapore M3U', url: 'https://iptv-org.github.io/iptv/countries/sg.m3u', type: 'm3u' },
    '9': { name: '🇰🇭Cambodia M3U', url: 'https://iptv-org.github.io/iptv/countries/kh.m3u', type: 'm3u' },
    '10': { name: '🇨🇳China M3U', url: 'https://iptv-org.github.io/iptv/countries/cn.m3u', type: 'm3u' },
  };

  const playlists = { ...basePlaylists };
  customPlaylists.forEach((pl, i) => {
    const id = `c${i + 1}`;
    playlists[id] = pl;
  });

  useEffect(() => {
    const loadPlaylist = async () => {
      setLoading(true);
      try {
        const { url, type } = playlists[selectedPlaylist];

        if (type === 'json') {
          const res = await fetch(url);
          const data = await res.json();
          const parsed = data.map(item => ({
            name: item.title,
            group: item.category || 'Others',
            url: item.url,
            logo: item.logo,
            year: item.year || 'Unknown'
          }));
          setChannels(parsed);
          setFiltered(parsed);
        } else {
          const res = await fetch(url.startsWith('http') ? proxy + encodeURIComponent(url) : url);
          const text = await res.text();
          const lines = text.split('\n');
          const parsed = [];
          let name = '', group = '', logo = '';

          lines.forEach((line) => {
            if (line.startsWith('#EXTINF')) {
              name = line.split(',')[1]?.trim() || 'Unnamed';
              const groupMatch = line.match(/group-title="([^"]+)"/);
              group = groupMatch ? groupMatch[1] : 'Others';
              const logoMatch = line.match(/tvg-logo="([^"]+)"/);
              logo = logoMatch ? logoMatch[1] : '';
            } else if (line.startsWith('http')) {
              parsed.push({ name, group, url: line.trim(), logo, year: 'Unknown' });
            }
          });

          setChannels(parsed);
          setFiltered(parsed);
        }
      } catch (err) {
        console.error('Error loading playlist:', err);
        setChannels([]);
        setFiltered([]);
      } finally {
        setLoading(false);
      }
    };

    loadPlaylist();
  }, [selectedPlaylist]);

  useEffect(() => {
    let temp = [...channels];
    if (group !== 'All') temp = temp.filter(c => c.group === group);
    if (year !== 'All') temp = temp.filter(c => c.year === year);
    if (search) temp = temp.filter(c => c.name.toLowerCase().includes(search.toLowerCase()));
    setFiltered(temp);
  }, [group, search, year, channels]);

  const toggleFavorite = (url) => {
    let favs = [...favorites];
    if (favs.includes(url)) {
      favs = favs.filter(f => f !== url);
    } else {
      favs.push(url);
    }
    setFavorites(favs);
    localStorage.setItem('favs', JSON.stringify(favs));
  };

  const openWithExternalPlayer = (url) => {
    const isAndroid = /Android/i.test(navigator.userAgent);
    const fallbackUrl = 'https://play.google.com/store/apps/details?id=com.genuine.leone';
    const intentUrl = `intent:${url}#Intent;package=com.genuine.leone;type=video/*;S.title=MMTV%20SPORT;end`;

    if (isAndroid) {
      let timeout;

      const iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      iframe.src = intentUrl;
      document.body.appendChild(iframe);

      setTimeout(() => {
        document.body.removeChild(iframe);
      }, 1000);

      timeout = setTimeout(() => {
        setPlayStoreUrl(fallbackUrl);
        setShowModal(true);
      }, 1500);

      const handleVisibility = () => {
        if (document.visibilityState === 'hidden') {
          clearTimeout(timeout);
        }
      };

      document.addEventListener('visibilitychange', handleVisibility, { once: true });
    } else {
      alert('Only available on Android.');
    }
  };

  const uniqueGroups = ['All', 'Favorites', ...new Set(channels.map(c => c.group || 'Others'))];
  const uniqueYears = ['All', ...new Set(channels.map(c => c.year || 'Unknown'))];

  const displayChannels =
    group === 'Favorites'
      ? channels.filter((c) => favorites.includes(c.url) && c.name.toLowerCase().includes(search.toLowerCase()))
      : filtered;

  return (
    <div style={{ padding: '20px' }}>
      <h2 style={{ textAlign: 'center', color: 'var(--accent-color)' }}>⏬For More Playlist ‌Press Under Button⏬</h2>

      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', marginBottom: '20px', justifyContent: 'center' }}>
        <select value={selectedPlaylist} onChange={(e) => setSelectedPlaylist(e.target.value)} style={{ padding: '6px', fontWeight: 'bold' }}>
          {Object.entries(playlists).map(([id, data]) => (
            <option key={id} value={id}>{data.name}</option>
          ))}
        </select>

        <input type="text" placeholder="🔍 Search channels" value={search} onChange={(e) => setSearch(e.target.value)} />

        <select value={group} onChange={(e) => setGroup(e.target.value)}>
          {uniqueGroups.map((g, i) => (
            <option key={i} value={g}>{g}</option>
          ))}
        </select>

        <select value={year} onChange={(e) => setYear(e.target.value)}>
          {uniqueYears.map((y, i) => (
            <option key={i} value={y}>{y}</option>
          ))}
        </select>
      </div>

      {loading ? (
        <p style={{ textAlign: 'center' }}>⏳ Loading channels...</p>
      ) : displayChannels.length === 0 ? (
        <p style={{ textAlign: 'center' }}>❌ No channels found.</p>
      ) : (
        <div className="grid">
          {displayChannels.map((ch, i) => (
            <ChannelCard
              key={i}
              name={ch.name}
              url={ch.url}
              logo={ch.logo}
              group={ch.group}
              year={ch.year}
              isFavorite={favorites.includes(ch.url)}
              toggleFavorite={() => toggleFavorite(ch.url)}
              openWithExternalPlayer={() => openWithExternalPlayer(ch.url)}
              isSelected={selectedUrl === ch.url} // ✅
              onSelect={() => setSelectedUrl(ch.url)} // ✅
            />
          ))}
        </div>
      )}

      {showModal && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.7)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999 }}>
          <div style={{ background: '#fff', borderRadius: '16px', padding: '24px', width: '90%', maxWidth: '340px', textAlign: 'center', boxShadow: '0 4px 10px rgba(0,0,0,0.2)' }}>
            <img src="https://live4u-github-io.vercel.app/poster+icon/nsplayericon.jpg" alt="MMTV SPORT Player" style={{ width: '80px', marginBottom: '12px' }} />
            <h3 style={{ margin: '8px 0', color: '#222' }}>MMTV SPORT Player Not Found</h3>
            <p style={{ color: '#666' }}>To watch this content, please install the external player first.</p>
            <div style={{ marginTop: '16px' }}>
              <a href={playStoreUrl} target="_blank" rel="noopener noreferrer" style={{ backgroundColor: '#007bff', color: '#fff', padding: '10px 18px', borderRadius: '8px', textDecoration: 'none', fontWeight: 'bold' }}>
                Install Player
              </a>
            </div>
            <button onClick={() => setShowModal(false)} style={{ marginTop: '12px', background: 'transparent', border: 'none', color: '#007bff', textDecoration: 'underline', cursor: 'pointer' }}>
              Cancel
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default Playlist;
